module.exports = __webpack_public_path__ + "static/media/noticiaComision.de094c46.svg";